module.exports = __webpack_public_path__ + "static/media/icon_changyonghaoma.6fe94d63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_changyonghaoma.svg
// module id = 724
// module chunks = 0